<template>
<el-dialog :visible.sync="show" append-to-body title="导入结果" width="410px">
  <div class="content">
    <!-- 总上报 {{ importResult['总共订单数'] || 0 }}，有效 {{ importResult['有效订单数'] || 0 }}，无效 {{ importResult['无效订单数'] || 0 }}
    <span v-if="importResult['重复订单号'] && importResult['重复订单号'].length">，重复 {{ importResult['重复订单号'].length }}</span> -->

    <!-- 有效对应已跟单 无效对应查询中 -->
    <!-- 总上报1，查询中0，已跟单0，已丢单0，重复1 -->
    总上报{{ importResult['总共订单数'] || 0 }}，查询中{{ importResult['无效订单数'] || 0 }}，已跟单{{ importResult['有效订单数'] || 0 }}，已丢单0，自己重复报单{{ importResult['重复订单号'].length - importResult['已被他人报单'].length }}，已被他人报单{{ importResult['已被他人报单'].length }}  </div>
  <div slot="footer">
    <el-button size="mini" @click="$emit('on-success')">关闭</el-button>
    <el-button size="mini" @click="exportExcel" type="primary">导出结果表</el-button>
  </div>
</el-dialog>
</template>

<script>
import { getFields, getZsFields } from '@/page/component/routes/index/order-manage/order-list/fields.js'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { queryExportOrderReportWeb } from '@/service/apis/order'
const dayjs = require('dayjs')
export default {
  name: 'addResultDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }, 
    importResult: {
      type: Object,
      default: () => ({})
    },
    roleType: {
      type: Number,
      default: null
    },
    reportType: {
      type: String,
      default: ''
    },
  }, 
  computed: {
    fields () {
      if (this.reportType === 'ZS') {
        return getZsFields(this.roleType)
      }
      return getFields(this.roleType)
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    
    exportExcel () {
      const heads = []
      const baseKeys = []
      this.fields.forEach(item => {
        if (typeof item.needExport === 'undefined' || (typeof item.needExport === 'function' && item.needExport(this.roleType))) {
          let label = item.label
          // 下游渠道 不显示开头‘下游’
          if (this.roleType == 4 && label.indexOf('下游') === 0) {
            label = label.replace('下游', '')
          }
          heads.push(label)
          baseKeys.push(item.key)
        }
      })
      
      // const statusLineIndex = heads.indexOf('报单状态')
      const data = [
        [...heads, '是否重复报单']
      ]

      const successList = this.importResult['已导入订单号'] || []
      const cfList = this.importResult['重复订单号'] || []
      const zjCfList = this.importResult['重复报单'] || [] // 自己重复
      // const wxList = this.importResult['无效订单ID'] || []
      const list = []
      // 成功
      successList.forEach(item => {
        const find = list.find(order => item == order.thirdOrderSn)
        if (!find) {
          list.push({
            thirdOrderSn: item
          })
        }
      })
      // 重复
      cfList.forEach(item => {
        const find = list.find(order => item == order.thirdOrderSn)
        if (!find) {
          list.push({
            thirdOrderSn: item
          })
        }
      })
      // // 无效
      // wxList.forEach(item => {
      //   const find = list.find(order => item == order.thirdOrderSn)
      //   if (!find) {
      //     list.push({
      //       thirdOrderSn: item
      //     })
      //   }
      // })
      const loading = this.$loading({
        lock: true,
        text: '正在导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 通过订单号查询列表
      const ids = list.map(item => item.thirdOrderSn)
      let opt = {
        thirdOrderSnList: [...ids],
        pageIndex: 1,
        pageSize: ids.length
      }
      if (this.reportType) {
        opt.reportTypeList = [this.reportType]
      }

      queryExportOrderReportWeb.call(this, opt).then((res) => {
        const records = res.records || []
        ids.forEach(id => {
          let values = []
          const isSuccess = successList.includes(id)
          const isZjCf = zjCfList.includes(id)
          if (isSuccess || isZjCf) {
            let statusValue = isSuccess ? '新增报单' : '自己重复报单'
            const find = records.find(item => item.thirdOrderSn == id) || {}
            this.fields.forEach(field => {
              if (typeof field.needExport === 'undefined' || (typeof field.needExport === 'function' && field.needExport(this.roleType))) {
                let val = find[field.key] || ''
                if (field.format) {
                  val = field.format(find)
                }
                values.push(field.type === 'number' ? { t: 's', v: val } : val)
              }
            })
            values.push(statusValue)

            data.push(values)
          } else {
            values = []
            // 已被他人报单
            values.length = data[0].length
            values[0] = id
            values[values.length - 1] = '已被他人报单'

            data.push(values)
          }

        }) 
        this.saveFile(data, loading)
      }).catch((e) => {
        console.log(e)
        this.$message.error('导出失败，请稍后再试')
        loading.close()
      })

      // list.forEach(item => {
      //   const values = []
      //   const find = successList.find(findItem => findItem.thirdOrderSn == item)
      //   this.fields.forEach(field => { 
      //     if (find) {
      //       if (typeof field.needExport === 'undefined' || (typeof field.needExport === 'function' && field.needExport())) {
      //         let val = find[field.key] || ''
      //         if (field.format) {
      //           val = field.format(find)
      //         }
      //         values.push(field.type === 'number' ? { t: 's', v: val } : val)
      //       }
      //     } else {
      //       if (field.key === 'thirdOrderSn') {
      //         // 编号
      //         values.push(item)
      //       } else {
      //         values.push('')
      //       }
      //     }
      //   }) 

      //   values.push(find ? '有效' : '无效')

      //   data.push(values)
      // })
    },
    saveFile (data, loading) {
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data)

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

      // 使用blob和FileReader创建一个URL然后下载
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
      // 
      saveAs(dataBlob, `导入结果 ${dayjs().format('YYYYMMDDHHmmss')}.xlsx`)
      loading.close()
    }
  }
}
</script>
<style scoped>
.content {
  line-height: 22px;
}
</style>